export default "__VITE_ASSET__CvmU7aJq__"